import { render, staticRenderFns } from "./BenefitsCards.vue?vue&type=template&id=1ac0ba29&"
import script from "./BenefitsCards.vue?vue&type=script&lang=ts&"
export * from "./BenefitsCards.vue?vue&type=script&lang=ts&"
import style0 from "./BenefitsCards.vue?vue&type=style&index=0&id=1ac0ba29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports